import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TProductImageOrderService = {
  payload: {
    productId: string
  }
}

export const productImageOrderService = async ({
  payload,
}: TProductImageOrderService): Promise<ResponseAPI> => {
  const response = await api.get(`produtofoto/${payload.productId}`)

  return response.data
}
